'use client';

import { Entry } from 'contentful';
import { TypeFaqListSkeleton } from '../../../../interfaces/contentful/TypeFaqList';
import { getFAQDataFromContentful } from '../../../../components/FAQ/helpers/getFAQDataFromContentful';
import { FAQ } from '../../../../components/FAQ/FAQ';

interface IProps {
  faqList: Entry<TypeFaqListSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>;
}

export const FAQSection = ({ faqList }: IProps) => {
  const { title, faqs } = faqList.fields;
  const faqData = faqs ? getFAQDataFromContentful({ faqs }) : [];

  return <FAQ showMoreFAQ={true} faqData={faqData} title={title} />;
};
